import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api/client.js';

/**
 * Log the user out. Clears server session + local query cache.
 * On success, the `/auth/me` query re-runs and returns null,
 * which flips the app back to the login screen via App.jsx routing.
 */
export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.post('/auth/logout'),
    onSuccess: () => {
      qc.setQueryData(['auth', 'me'], null);
      qc.invalidateQueries();
    },
  });
}
